import e from "./getCmapiCookiePrivacyValue.mjs";
import r from "./hasConsentedToOldVersion.mjs";
const a = ({ latestPolicyVersion: o }) => r({
  latestPolicyVersion: o
}) || !e();
export {
  a as default
};
